import { useNavigate } from "react-router-dom";
import { getFromLocalStorage } from "../../utils/storageUtil";
import { useEffect } from "react";


const ResetPassGuard = ({ children }) => {
    const navigate = useNavigate();
    const isEmailVerified = getFromLocalStorage('isEmailVerified');
    const isOtpVerified = getFromLocalStorage('isOtpVerified');


    useEffect(() => {
        if (!isEmailVerified || !isOtpVerified) {
            navigate('/auth/forgot-password');
        }
    }, [])

    if (isEmailVerified && isOtpVerified) {
        return <>{children}</>;
    } else {
        navigate('/auth/forgot-password');
        return null;
    }
}

export default ResetPassGuard;